import {DeviceDetectionUtil} from 'cchome-shared/utils';
export default DeviceDetectionUtil;
